var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.VIDEO_CONSULTATION_STATE = {
    CONNECTED: 'CONNECTED',
    PATIENT_NETWORK_ISSUE: 'PATIENT_NETWORK_ISSUE',
    CONNECTING: 'CONNECTING',
    FINISHED: 'FINISHED',
    ERROR: 'ERROR'
};

Object.freeze(Enum.MEEDY.VIDEO_CONSULTATION_STATE);